module.exports = __webpack_public_path__ + "img/ubq.126ad822.svg";